class OTPRequest{
    OTPurl(mobile,email,countryCode, GToken){
        return process.env.REACT_APP_BASEURL+"CreateOTP/"+mobile+"/"+email+"/"+countryCode+"/"+GToken;
    }
    OTPVerification(mobile,otp){
        return process.env.REACT_APP_BASEURL+"OtpVerification/"+mobile+"/"+otp;
    }
}
export const {OTPurl,OTPVerification}=new OTPRequest()